module.exports = __webpack_public_path__ + "static/img/stay-option-icon-beauty.469bcc96.svg";